/**
 * Determines if an albumFolder should have the auto-join null state enabled or not.
 *
 * @param {Object} albumFolder The album folder to check
 * @returns {boolean} Whether or not auto-join null-state is supported.
 */
import { ALL_PHOTOS_MODE } from '../../../../constants/album-folder';

export const supportsAutoJoinNullState = albumFolder => {
  if (!albumFolder) {
    return false;
  }

  if (
    !albumFolder.all_photos_mode ||
    albumFolder.all_photos_mode === ALL_PHOTOS_MODE.NONE
  ) {
    return false;
  }

  return (
    (!albumFolder.joins_enabled || albumFolder.matching_disabled) &&
    !albumFolder.has_album_photos
  );
};
